import { GAME_ID, REDUX_ACTIONS, WORKFLOW } from 'a/directorsCut/data/constants';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

const initState = {
  [WORKFLOW.QUEST]: [],
  [WORKFLOW.PRACTICE]: [],
  isLoaded: false,
};

/*
const entry = {
  levelId: 0,
  startAt: 0,
  data: {},
};
*/

const gameDataReducer = (state = initState, { type, stateData, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const gameData = stateData[GAME_ID].GameData || {};
      const details = gameData.gameDetails || {};

      // Merge assignment-based saves with existing state
      // Assignment saves are stored with assignmentId as key
      const assignmentSaves = {};
      Object.keys(details).forEach((key) => {
        // If the key is not QUEST, PRACTICE, or isLoaded, it's an assignment ID
        if (![WORKFLOW.QUEST, WORKFLOW.PRACTICE, 'isLoaded'].includes(key)) {
          assignmentSaves[key] = details[key];
        }
      });

      return {
        ...state,
        [WORKFLOW.QUEST]: details[WORKFLOW.QUEST] || state[WORKFLOW.QUEST],
        [WORKFLOW.PRACTICE]: details[WORKFLOW.PRACTICE] || state[WORKFLOW.PRACTICE],
        ...assignmentSaves,
        isLoaded: true,
      };
    }

    case persistStateTypes.REQUESTERROR_GAMESTATE_ALL: {
      return {
        ...state,
        isLoaded: true,
      };
    }

    case REDUX_ACTIONS.UPDATE_GAME_DATA:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
};

export default gameDataReducer;
